import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import { N as NextHead } from './NextHead-828BS7ON.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { CoreContext } from './context/index.js';
import Link from './components/Link/index.js';

const Page404 = () => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const { data: { siteConfig: { notFoundPage: { button = false } = {} }, }, } = useContext(CoreContext);
    const meta = {
        title: `${t('$local.$meta.meta_title')} - ${tValidation('pageNotFound')}`,
        description: `${t('$local.$meta.meta_title')} - ${tValidation('pageNotFound')}`,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NextHead, { meta: meta }),
        React.createElement("div", { className: "container pg404", id: "page-404" },
            React.createElement("div", { className: "tagline-wrap" },
                React.createElement("h1", null, tValidation('pageNotFound')),
                React.createElement("section", null,
                    React.createElement("h2", null, tCommon('tips404_1')),
                    React.createElement("section", null,
                        button && (React.createElement(Link, { href: "/", className: "btn-main btn-go-back" }, tCommon('$buttons.continueShopping'))),
                        React.createElement("h3", null, tCommon('tips404_2')),
                        React.createElement("p", null,
                            "- ",
                            tCommon('tips404_3')),
                        React.createElement("p", null,
                            "- ",
                            tCommon('tips404_4'))))))));
};
var Page404$1 = withProviders(Page404, { translation: true });

export { Page404$1 as P };
//# sourceMappingURL=Page404-4293xKbg.js.map
